import React from 'react';
import MenuContent from '../MenuContent';
import NavList from '../NavList';

const InclusionsBlock = ({ inclusions = [] }) => {

  const inclusionJSX = inclusions.map(inclusion => {

    const {className, heading, links, additionalInformation} = inclusion;

    return (
      <NavList key={heading.label} className={`sm-12 ${className}`}>
        <h4 className={heading.headerClassName}>
          <a href={heading.link}>{heading.label}</a>
        </h4>
        <ul className="col-lg-3">
          {
            links.map(item => (
              <li key={item.link}>
                <a href={item.link}>{item.label}</a>
              </li>
            ))
          }
        </ul>
        {
          additionalInformation &&
          <div className="additional-info">{additionalInformation}</div>
        }
      </NavList>
    );
  });


  return (
    <MenuContent className="inclusions-block row">
      {inclusionJSX}
    </MenuContent>
  );
};

InclusionsBlock.defaultProps = {
  inclusions: [],
};

export default InclusionsBlock;



// WEBPACK FOOTER //
// ./js/components/global/menu/menuBlocks/InclusionsBlock.js